export default "__VITE_ASSET__28cd31fe__"